//imports
import { all } from 'redux-saga/effects';

//Views
import companyOverviewSagas from 'Modules/accounts/views/overview/redux/saga';
import purgeAccountSagas from 'Modules/accounts/views/components/purgeAccount/redux/saga';
import createEditAccountSagas from 'Modules/accounts/views/components/createEditAccount/redux/saga';
import changeStatusAccountSagas from 'Modules/accounts/views/components/changeStatus/redux/saga';
import resetCompAuthenticationSagas from 'Modules/accounts/views/components/resetCompanyAuthentication/redux/saga';
import advancedFiltersSagas from 'Modules/accounts/views/main/.components/AdvancedFilters/redux/saga';
import systemAlertLastReadingInfoSagas from 'Modules/accounts/.components/systemAlertLogsTab/.components/lastReadingInfo/redux/saga';
import accountDetailsSagas from 'Modules/accounts/views/main/.components/details/redux/saga';
import accountExportLogsSagas from 'Modules/accounts/.components/exportLogs/redux/saga';
import reprocessOdoHoursSagas from 'Modules/accounts/.components/reprocessOdoHours/redux/saga';
import systemAlertLogsContactsSagas from 'Modules/accounts/.components/systemAlertLogsTab/.components/contacts/redux/saga';
import changeUsernameSagas from 'Modules/accounts/.components/changeUsername/redux/saga';
import promilesRequestSagas from 'Modules/accounts/views/components/promilesRequest/redux/saga';
import addIntegrationSagas from 'Modules/accounts/.components/addIntegration/redux/saga';
import viewCerebrumXIntegrationSagas from 'Modules/accounts/.components/viewCerebrumXIntegration/redux/saga';
import addCerebrumXOEMSagas from 'Modules/accounts/.components/addCerebrumXOEM/redux/saga'; 
import deleteCerebrumXIntegrationSagas from 'Modules/accounts/.components/deleteCerebrumXIntegration/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        companyOverviewSagas(),
        purgeAccountSagas(),
        createEditAccountSagas(),
        changeStatusAccountSagas(),
        resetCompAuthenticationSagas(),
        advancedFiltersSagas(),
        systemAlertLastReadingInfoSagas(),
        accountDetailsSagas(),
        accountExportLogsSagas(),
        reprocessOdoHoursSagas(),
        systemAlertLogsContactsSagas(),
        changeUsernameSagas(),
        promilesRequestSagas(),
        addIntegrationSagas(),
        viewCerebrumXIntegrationSagas(),
        addCerebrumXOEMSagas(),
        deleteCerebrumXIntegrationSagas()
    ]);
}